"use strict";

require("core-js/modules/es6.string.link");

var _classCallCheck = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/inherits");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactJss = require("react-jss");

var _Typography = _interopRequireDefault(require("@aetn/ui-core/Typography"));

var _Title = _interopRequireDefault(require("./Title.styles"));

var _class, _class2, _temp;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof _WeakMap !== "function") return null;
  var cache = new _WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        _Object$defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Title = (0, _Title["default"])(_class = (0, _reactJss.withTheme)(_class = (_temp = _class2 =
/*#__PURE__*/
function (_react$Component) {
  _inherits(Title, _react$Component);

  function Title() {
    _classCallCheck(this, Title);

    return _possibleConstructorReturn(this, _getPrototypeOf(Title).apply(this, arguments));
  }

  _createClass(Title, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          classes = _this$props.classes,
          link = _this$props.link,
          title = _this$props.title,
          description = _this$props.description;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.root, className)
      }, _react["default"].createElement("a", {
        className: classes.link,
        href: link
      }, _react["default"].createElement("strong", {
        className: classes.logo
      }, title)), _react["default"].createElement(_Typography["default"], {
        tag: "span",
        className: classes.description
      }, description));
    }
  }]);

  return Title;
}(_react.Component), _class2.propTypes = {
  link: _propTypes.string.isRequired,
  title: _propTypes.string.isRequired,
  description: _propTypes.string.isRequired
}, _temp)) || _class) || _class;

exports["default"] = Title;